import React, { memo } from 'react';
import styled, { css } from 'styled-components';
import { IForecastCard } from '../../common/types';

type InfoProps = Pick<IForecastCard, 'hour' | 'description'>;

export const HourCardInfo = memo(({ hour = '', description = '' }: InfoProps) => {
    return (
        <Container>
            <InfoTime>
                {hour}
            </InfoTime>
            <Description>
                {description}
            </Description>
        </Container>
    );
});

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: calc(100% - 50px - 68px);
    padding: 0 6px;
`;

const CommonInfoStyles = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    color: #666;
    width: 100%;
`;

const InfoTime = styled.div`
    ${CommonInfoStyles}
    font-size: 15px;
    font-weight: 600;
    height: 25px;
`;

const Description = styled.div`
    ${CommonInfoStyles}
    font-size: 13px;
    font-weight: 400;
    height: 17px;
`;
